"use client"

import React from "react"

import AffixWrapper from "./AffixWrapper"
import BackToTop from "./BackToTop"
import type { UnionIconAffixProps } from "./type"

export type { UnionIconAffixProps } from "./type"

const UnionIconAffix: React.FC<UnionIconAffixProps> = (props) => {
  return (
    <>
      {/* {showAssistant && (
        <AffixWrapper {...props} visibleOffset={-1} bottom={87}>
          <Assistant
            text={{
              title: t("title"),
              description: t("description"),
              action: t("action"),
            }}
          />
        </AffixWrapper>
      )} */}
      <AffixWrapper {...props}>
        <BackToTop />
      </AffixWrapper>
    </>
  )
}

export default UnionIconAffix
